import { toURLSearchParams } from '@wix/metro-runtime';
import { serializer } from '@wix/metro-runtime/ambassador';
import { resolveUrl } from '@wix/metro-runtime';
var _abortAssistantMessageGenerationRequest = {};
var _abortAssistantMessageGenerationResponse = {};
var _conversation = { createdDate: 'google.protobuf.Timestamp' };
var _conversationMessage = { createdDate: 'google.protobuf.Timestamp' };
var _createConversationRequest = {};
var _createConversationResponse = {};
var _createConversationUserMessageRequest = {};
var _createConversationUserMessageResponse = {
    userMessage: '_conversationMessage',
};
var _getConversationMessageRequest = {};
var _getConversationMessageResponse = {
    conversationMessage: '_conversationMessage',
};
var _getConversationMessagesRequest = {};
var _getConversationMessagesResponse = { messages: '_conversationMessage' };
var _getConversationsRequest = {};
var _getConversationsResponse = { conversations: '_conversation' };
var _getSpeechToTextRequest = { audioData: 'BYTES' };
var _getSpeechToTextResponse = {};
var _getTextToSpeechRequest = {};
var _getTextToSpeechResponse = { audioData: 'BYTES' };
var _getVoiceConversationSettingsRequest = {};
var _getVoiceConversationSettingsResponse = {};
var _getVoiceConversationSignedUrlRequest = {};
var _getVoiceConversationSignedUrlResponse = {};
var _log = { timestamp: 'google.protobuf.Timestamp' };
var _sendMessageRequest = {};
var _sendMessageResponse = {
    assistantMessages: '_conversationMessage',
    logs: '_log',
    userMessage: '_conversationMessage',
};
var _sendSimpleMessageRequest = {};
var _sendSimpleMessageResponse = {
    assistantMessages: '_conversationMessage',
    userMessage: '_conversationMessage',
};
var _updateWidgetRequest = {};
var _updateWidgetResponse = {};
function resolveWixGenieChatServiceV1ChatServiceUrl(opts) {
    var domainToMappings = {
        'bo._base_domain_': [
            {
                srcPath: '/_serverless/chat-service',
                destPath: '',
            },
        ],
        'wixbo.ai': [
            {
                srcPath: '/_serverless/chat-service',
                destPath: '',
            },
        ],
        'wix-bo.com': [
            {
                srcPath: '/_serverless/chat-service',
                destPath: '',
            },
        ],
        'manage._base_domain_': [
            {
                srcPath: '/_serverless/chat-service',
                destPath: '',
            },
        ],
        'editor._base_domain_': [
            {
                srcPath: '/_serverless/chat-service',
                destPath: '',
            },
        ],
        'blocks._base_domain_': [
            {
                srcPath: '/_serverless/chat-service',
                destPath: '',
            },
        ],
        'create.editorx': [
            {
                srcPath: '/_serverless/chat-service',
                destPath: '',
            },
        ],
        'www._base_domain_': [
            {
                srcPath: '/_serverless/chat-service',
                destPath: '',
            },
        ],
        'manage.nownia.com': [
            {
                srcPath: '/_serverless/chat-service',
                destPath: '',
            },
        ],
        'api._api_base_domain_': [
            {
                srcPath: '/chat-service',
                destPath: '',
            },
        ],
        _: [
            {
                srcPath: '/_api/chat-service',
                destPath: '',
            },
        ],
        'vibe._base_domain_': [
            {
                srcPath: '/_api/chat-service',
                destPath: '',
            },
        ],
        'www.wixapis.com': [
            {
                srcPath: '/ai-assistant/chat-service',
                destPath: '',
            },
        ],
    };
    return resolveUrl(Object.assign(opts, { domainToMappings: domainToMappings }));
}
/** Returns a list of Сonversations for the given origin */
export function getTextToSpeech(payload) {
    var _a = serializer(_getTextToSpeechRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getTextToSpeechResponse, {}).fromJSON;
    function __getTextToSpeech(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.genie.chat_service.v1.no_entity',
            method: 'GET',
            methodFqn: 'wix.genie.chat_service.v1.ChatService.GetTextToSpeech',
            url: resolveWixGenieChatServiceV1ChatServiceUrl({
                protoPath: '/v1/text-to-speech',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getTextToSpeech.fromReq = fromReq;
    __getTextToSpeech.__isAmbassador = true;
    return __getTextToSpeech;
}
/** Convert speech to text */
export function getSpeechToText(payload) {
    var _a = serializer(_getSpeechToTextRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getSpeechToTextResponse, {}).fromJSON;
    function __getSpeechToText(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.genie.chat_service.v1.no_entity',
            method: 'POST',
            methodFqn: 'wix.genie.chat_service.v1.ChatService.GetSpeechToText',
            url: resolveWixGenieChatServiceV1ChatServiceUrl({
                protoPath: '/v1/speech-to-text',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getSpeechToText.fromReq = fromReq;
    __getSpeechToText.__isAmbassador = true;
    return __getSpeechToText;
}
/** Returns a list of Сonversations for the given origin */
export function getConversations(payload) {
    var _a = serializer(_getConversationsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getConversationsResponse, {
        _conversation: _conversation,
    }).fromJSON;
    function __getConversations(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.genie.chat_service.v1.no_entity',
            method: 'GET',
            methodFqn: 'wix.genie.chat_service.v1.ChatService.GetConversations',
            url: resolveWixGenieChatServiceV1ChatServiceUrl({
                protoPath: '/v1/conversations',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getConversations.fromReq = fromReq;
    __getConversations.__isAmbassador = true;
    return __getConversations;
}
/** Create a new Сonversation */
export function createConversation(payload) {
    var _a = serializer(_createConversationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createConversationResponse, {}).fromJSON;
    function __createConversation(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.genie.chat_service.v1.no_entity',
            method: 'POST',
            methodFqn: 'wix.genie.chat_service.v1.ChatService.CreateConversation',
            url: resolveWixGenieChatServiceV1ChatServiceUrl({
                protoPath: '/v1/conversations',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createConversation.fromReq = fromReq;
    __createConversation.__isAmbassador = true;
    return __createConversation;
}
/** Returns a list of messages for the given Сonversation ID */
export function getConversationMessages(payload) {
    var _a = serializer(_getConversationMessagesRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getConversationMessagesResponse, {
        _conversationMessage: _conversationMessage,
    }).fromJSON;
    function __getConversationMessages(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.genie.chat_service.v1.no_entity',
            method: 'GET',
            methodFqn: 'wix.genie.chat_service.v1.ChatService.GetConversationMessages',
            url: resolveWixGenieChatServiceV1ChatServiceUrl({
                protoPath: '/v1/conversation-messages',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData, true),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getConversationMessages.fromReq = fromReq;
    __getConversationMessages.__isAmbassador = true;
    return __getConversationMessages;
}
/** Returns message history for the given conversation message ID */
export function getConversationMessage(payload) {
    var _a = serializer(_getConversationMessageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getConversationMessageResponse, {
        _conversationMessage: _conversationMessage,
    }).fromJSON;
    function __getConversationMessage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.genie.chat_service.v1.no_entity',
            method: 'GET',
            methodFqn: 'wix.genie.chat_service.v1.ChatService.GetConversationMessage',
            url: resolveWixGenieChatServiceV1ChatServiceUrl({
                protoPath: '/v1/conversation-message/{messageId}',
                data: serializedData,
                host: host,
            }),
            params: toURLSearchParams(serializedData),
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getConversationMessage.fromReq = fromReq;
    __getConversationMessage.__isAmbassador = true;
    return __getConversationMessage;
}
/** Create a user message in an existing conversation */
export function createConversationUserMessage(payload) {
    var _a = serializer(_createConversationUserMessageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_createConversationUserMessageResponse, { _conversationMessage: _conversationMessage }).fromJSON;
    function __createConversationUserMessage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.genie.chat_service.v1.no_entity',
            method: 'POST',
            methodFqn: 'wix.genie.chat_service.v1.ChatService.CreateConversationUserMessage',
            url: resolveWixGenieChatServiceV1ChatServiceUrl({
                protoPath: '/v1/conversation-user-message',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __createConversationUserMessage.fromReq = fromReq;
    __createConversationUserMessage.__isAmbassador = true;
    return __createConversationUserMessage;
}
/** Handle new user message or report function call results */
export function sendMessage(payload) {
    var _a = serializer(_sendMessageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendMessageResponse, {
        _conversationMessage: _conversationMessage,
        _log: _log,
    }).fromJSON;
    function __sendMessage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.genie.chat_service.v1.no_entity',
            method: 'POST',
            methodFqn: 'wix.genie.chat_service.v1.ChatService.SendMessage',
            url: resolveWixGenieChatServiceV1ChatServiceUrl({
                protoPath: '/v1/user-message',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendMessage.fromReq = fromReq;
    __sendMessage.__isAmbassador = true;
    return __sendMessage;
}
/** Handle new user message with a simplified request containing only the user message */
export function sendSimpleMessage(payload) {
    var _a = serializer(_sendSimpleMessageRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_sendSimpleMessageResponse, {
        _conversationMessage: _conversationMessage,
    }).fromJSON;
    function __sendSimpleMessage(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.genie.chat_service.v1.no_entity',
            method: 'POST',
            methodFqn: 'wix.genie.chat_service.v1.ChatService.SendSimpleMessage',
            url: resolveWixGenieChatServiceV1ChatServiceUrl({
                protoPath: '/v1/simple-user-message',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __sendSimpleMessage.fromReq = fromReq;
    __sendSimpleMessage.__isAmbassador = true;
    return __sendSimpleMessage;
}
/** update widget */
export function updateWidget(payload) {
    var _a = serializer(_updateWidgetRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_updateWidgetResponse, {}).fromJSON;
    function __updateWidget(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.genie.chat_service.v1.no_entity',
            method: 'POST',
            methodFqn: 'wix.genie.chat_service.v1.ChatService.UpdateWidget',
            url: resolveWixGenieChatServiceV1ChatServiceUrl({
                protoPath: '/v1/update-widget',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __updateWidget.fromReq = fromReq;
    __updateWidget.__isAmbassador = true;
    return __updateWidget;
}
/** Abort assistant message generation for a given user message ID */
export function abortAssistantMessageGeneration(payload) {
    var _a = serializer(_abortAssistantMessageGenerationRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_abortAssistantMessageGenerationResponse, {}).fromJSON;
    function __abortAssistantMessageGeneration(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.genie.chat_service.v1.no_entity',
            method: 'POST',
            methodFqn: 'wix.genie.chat_service.v1.ChatService.AbortAssistantMessageGeneration',
            url: resolveWixGenieChatServiceV1ChatServiceUrl({
                protoPath: '/v1/abort-assistant-message-generation',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __abortAssistantMessageGeneration.fromReq = fromReq;
    __abortAssistantMessageGeneration.__isAmbassador = true;
    return __abortAssistantMessageGeneration;
}
/** Get voice conversation settings */
export function getVoiceConversationSettings(payload) {
    var _a = serializer(_getVoiceConversationSettingsRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getVoiceConversationSettingsResponse, {}).fromJSON;
    function __getVoiceConversationSettings(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.genie.chat_service.v1.no_entity',
            method: 'POST',
            methodFqn: 'wix.genie.chat_service.v1.ChatService.GetVoiceConversationSettings',
            url: resolveWixGenieChatServiceV1ChatServiceUrl({
                protoPath: '/v1/voice-conversation/settings',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getVoiceConversationSettings.fromReq = fromReq;
    __getVoiceConversationSettings.__isAmbassador = true;
    return __getVoiceConversationSettings;
}
/** Get voice conversation signed url */
export function getVoiceConversationSignedUrl(payload) {
    var _a = serializer(_getVoiceConversationSignedUrlRequest, {}), toReq = _a.toJSON, fromReq = _a.fromJSON;
    var fromRes = serializer(_getVoiceConversationSignedUrlResponse, {}).fromJSON;
    function __getVoiceConversationSignedUrl(_a) {
        var host = _a.host;
        var serializedData = toReq(payload);
        var metadata = {
            entityFqdn: 'wix.genie.chat_service.v1.no_entity',
            method: 'POST',
            methodFqn: 'wix.genie.chat_service.v1.ChatService.GetVoiceConversationSignedUrl',
            url: resolveWixGenieChatServiceV1ChatServiceUrl({
                protoPath: '/v1/voice-conversation/signed-url',
                data: serializedData,
                host: host,
            }),
            data: serializedData,
            transformResponse: fromRes,
        };
        return metadata;
    }
    __getVoiceConversationSignedUrl.fromReq = fromReq;
    __getVoiceConversationSignedUrl.__isAmbassador = true;
    return __getVoiceConversationSignedUrl;
}
//# sourceMappingURL=http.impl.js.map